import { signalStore } from '@ngrx/signals';
import { withActions, withSelectors } from '@res/ngg-core';
import { ColumnState, FilterModel } from 'ag-grid-community';
import { PersonalPreferencesActions } from './personal-preferences.action';
import { PersonalPreferencesState } from './personal-preferences.state';

export interface PersonalPreferencesStateModel {
  defaultPageSize?: number;
  filter?: { [gridName: string]: FilterModel | undefined };
  sort?: { [gridName: string]: ColumnState[] | undefined };
}

export const PersonalPreferencesStore = signalStore(
  // Selectors
  { protectedState: false, providedIn: 'root' },

  // withParamSelectors({
  //   localSavedGridFilter: PersonalPreferencesState.localSavedGridFilter,
  // }),
  //   withMethods((store ) => ({
  //   //   localSavedGridFilter: (name: Signal<string>): Signal<FilterModel> => computed(() => {
  //   //     return store.filter.().findIndex(p => p.name == name()) >= 0;
  //   // })
  //   updateQuery(query: string): void {
  //     // 👇 Updating state using the `patchState` function.
  //     patchState(store, (state) => ({ filter: { ...state.filter, query } }));
  //   },

  // })),
  // withMethods((store:DeepSignal<PersonalPreferencesStateModel>) => ({
  //   localSavedGridFilter: (name: string): Signal<boolean> => computed(() => {
  //       return store.filter[name]()
  //   })
  // })),
  withSelectors({
    localSavedGridPaginationPageSize: PersonalPreferencesState.localSavedGridPaginationPageSize,
    localSavedGridFilter: PersonalPreferencesState.localSavedGridFilter,
    localSavedGridSort: PersonalPreferencesState.localSavedGridSort,
  }),
  // Actions
  withActions({
    saveGridPaginationPageSize: PersonalPreferencesActions.SaveGridPaginationPageSize,
    saveGridFilter: PersonalPreferencesActions.SaveGridFilter,
    saveGridSort: PersonalPreferencesActions.SaveGridSort,
  }),
);
